var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app-bar",
    {
      staticClass: "app-bar",
      attrs: {
        "clipped-left": "",
        app: "",
        height: "calculateHeight",
        flat: "",
        fixed: "",
      },
    },
    [
      _vm.checkIfIsTablet
        ? _c(
            "div",
            { staticClass: "tablet-header" },
            [
              _c(
                "router-link",
                {
                  staticClass: "logo-container",
                  attrs: { to: { name: _vm.logoRouteName } },
                },
                [_c("LefebvreLogoComponent")],
                1
              ),
              _c("AppBarToolbarItemsComponent"),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "app-bar-content" },
            [
              !_vm.checkIfIsTablet
                ? _c(
                    "router-link",
                    {
                      staticClass: "logo-container",
                      attrs: { to: { name: _vm.logoRouteName } },
                    },
                    [_c("LefebvreLogoComponent")],
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _vm.showSearchSection
                ? _c(
                    "div",
                    { staticClass: "search-section" },
                    [
                      _c("LexonSearchFieldComponent", {
                        on: { searchTerm: _vm.onSearchTerm },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("AppBarToolbarItemsComponent"),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }